"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
// Validation module
__exportStar(require("./validation"), exports);
// Formatting module
__exportStar(require("./formatting"), exports);
// Health module
__exportStar(require("./health"), exports);
// Types module
__exportStar(require("./types"), exports);
// Images module
__exportStar(require("./images"), exports);
// Locale module
__exportStar(require("./locale"), exports);
// Geography module
__exportStar(require("./geography"), exports);
// Config module
__exportStar(require("./config"), exports);
// Currencies module (EXFX-5)
__exportStar(require("./currencies"), exports);
// Membership module (RBAC-2.1) — ось C: роли членства в магазине и их способности
__exportStar(require("./membership"), exports);
// Roles module (RBAC-1.9) — оси A (тир доверия) и B (платформенная должность)
__exportStar(require("./roles"), exports);
// Permissions module (RBAC-2.3) — каталог прав: что имя даёт
__exportStar(require("./permissions"), exports);
